import React, { useRef } from "react";
import BundledEditor from "./BundledEditor";
import "./style.css";

const TinyEditor = ({ editorState, onEditorStateChange }) => {
  const editorRef = useRef(null);

  return (
    <BundledEditor
      ref={editorRef}
      onInit={(_evt, editor) => (editorRef.current = editor)}
      initialValue={editorState || ""}
      init={{
        height: 400,
        menubar: true,
        plugins: [
          "advlist",
          "anchor",
          "autolink",
          "help",
          "image",
          "link",
          "lists",
          "searchreplace",
          "table",
          "wordcount",
          "directionality",
        ],
        toolbar:
          "undo redo | blocks | bold italic forecolor | " +
          "alignleft aligncenter alignright alignjustify | " +
          "ltr rtl | bullist numlist outdent indent | removeformat | help",
        content_style: `
          body {
            font-family: Helvetica, Arial, sans-serif;
            font-size: 14px;
          }
        `,
        convert_fonts_to_spans: true,
        formats: {
          alignleft: { 
            selector: "p, h1, h2, div, ul, li", 
            styles: { textAlign: "left" } 
          },
          aligncenter: { 
            selector: "p, h1, h2, div, ul, li", 
            styles: { textAlign: "center" } 
          },
          alignright: { 
            selector: "p, h1, h2, div, ul, li",
            styles: { textAlign: "right" } 
          },
          alignjustify: { 
            selector: "p, h1, h2, div, ul, li", 
            styles: { textAlign: "justify" } 
          },
        },
        style_formats_merge: true,
        style_formats_autohide: false,
        setup: (editor) => {
          editor.on("Change", () => {
            const content = editor.getContent({ format: "html" }); // ⬅ HTML الفعلي
            onEditorStateChange(content);
          });
        },
      }}
    />
  );
};

export default TinyEditor;